import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { FamilyHistoryFormValues } from "./interface";

interface EditFieldsProps {
  formValues: FamilyHistoryFormValues;
  handleChange: (
    field: keyof FamilyHistoryFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledTextArea
        multiline
        label="Caregiver main concerns"
        value={formValues.caregiverMainConcerns}
        onChange={handleChange("caregiverMainConcerns")}
      />

      <LabeledTextArea
        multiline
        label="Daily Routine and structure"
        value={formValues.dailyRoutineStructure}
        onChange={handleChange("dailyRoutineStructure")}
        helperText="Document the client’s typical daily routines in the home including any notable family scheduling conflict, family work schedule, and any major life events impacting the client’s ability to participate in therapy"
      />

      <LabeledTextArea
        multiline
        label="Family and caregivers present in the home and others involved in care"
        value={formValues.familyCaregiversInHome}
        onChange={handleChange("familyCaregiversInHome")}
      />
    </Grid>
  );
};

export default EditFields;
